<template src="./SelectWithProvider.html">
</template>

<script>
  import { ValidationProvider, extend } from "vee-validate";
  import i18n from "../../i18n";

  extend('requiredList', {
    validate(value, { valueField, options }) {
      if (options && options.find(o => o !== undefined && o[valueField] === value) !== undefined) {
        return true;
      }
      return i18n.t('FieldRequired');
    },
    params: ['valueField', 'options']
  });

export default {
  data: () => ({
    innerValue: '',
    innerRules: "",
    validateImmediately: false
  }),
  props: {
    id: {
      type: String
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    options: {
      type: [Object, Array]
    },
    value: {
      default: null
    },
    valueField: {
      default: "id",
    },
    textField: {
      default: "name",
    },
  },
  components: {
    ValidationProvider
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
    this.innerRules = this.rules;
    let params = [this.valueField, this.options];
    if (this.innerRules === "required") {
      this.innerRules = { required: true, requiredList: params };
    } else if (typeof this.innerRules === 'object' && this.innerRules.required === true) {
      this.innerRules.requiredList = params;
    }
    this.validateImmediately = this.innerRules !== null && this.innerRules.required === true;
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    options(newVal) {
      if (this.innerRules.requiredList) {
        this.innerRules.requiredList = [this.valueField, newVal];
        this.$refs.observer.validate();
      }
    }
  }
};
</script>
